import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { BookButton } from './BookButton';
import { PhotoPlaceholder } from './PhotoPlaceholder';
export function FinalCta() {
  return <section aria-labelledby="final-cta-heading" className="relative overflow-hidden border-t border-gold/30 bg-navy py-28 text-paper md:py-40" data-id="element-49" data-mp="19g0dhjtkbyky">
      <div className="absolute inset-0" data-id="element-50" data-mp="1jd50tmz5a03c">
        <PhotoPlaceholder variant="background" src="https://cdn.magicpatterns.com/patterns/generated-images/e4c113ac-c2dd-4235-a9a7-67438215fc36.jpg" description="Folded American flag on a wooden table" alt="A ceremonially folded American flag resting on a wooden table in soft evening light." supplySize="2880 × 1400 px or larger" data-id="element-51" data-mp="1jc3hkv7z67aj" />
        <div aria-hidden="true" className="absolute inset-0 z-10 bg-navy/75" data-id="element-52" data-mp="224o47ux2zg5w" />
      </div>

      <Reveal className="relative z-10 mx-auto max-w-3xl px-6 text-center md:px-10" data-id="element-53" data-mp="1x5b6ug8l2qp2">
        <div aria-hidden="true" className="flex items-center justify-center gap-4" data-id="element-54" data-mp="n64b3n7yhqle">
          <span className="h-px w-12 bg-gold" data-id="element-55" data-mp="s4petwmf2sel" />
          <StarIcon className="h-4 w-4 fill-gold text-gold" strokeWidth={1} data-id="element-56" data-mp="s5gyqa6nj1p1" />
          <span className="h-px w-12 bg-gold" data-id="element-57" data-mp="x3ipzie8e7bl" />
        </div>
        <h2 id="final-cta-heading" className="mt-8 font-serif text-4xl font-semibold leading-tight md:text-6xl" data-id="element-58" data-mp="x64xji14gmtt">
          Not sure where to start? Start with a conversation.
        </h2>
        <p className="mx-auto mt-8 max-w-2xl text-lg leading-relaxed text-paper/85 md:text-xl" data-id="element-59" data-mp="162dwkvl6tjff">
          One free call. Tell us what happened. We'll tell you honestly how we can help. You've carried enough on
          your own.
        </p>
        <div className="mt-12 flex flex-col items-center gap-6" data-id="element-60" data-mp="1ktwcyuhylfzb">
          <BookButton data-id="element-61" data-mp="1kv7c2h0glzk3" />
          <a href="/contact-us" className="inline-flex min-h-[48px] items-center text-lg font-medium text-paper underline decoration-gold/70 underline-offset-[6px] transition-colors duration-150 ease-out hover:text-gold" data-id="element-62" data-mp="1pszggaiaje56">
            Contact Us
          </a>
        </div>
      </Reveal>
    </section>;
}